const DEFAULT_KLAS_ID = "KLAS_ID";

export default (router, store) => {
  router.beforeEach(async (to, from, next) => {
    const { disabled: isDisabled } = store.state.webshop;
    // disabled webshop?
    if (isDisabled) {
      // prevent inifite loop
      if (to.name === "disabled-webshop") {
        return next();
      } else {
        //console.debug("route-guard", { store, isDisabled, route: router.currentRoute.value, to, from });
        return next({ name: "disabled-webshop", query: { ...to.query, u: to.fullPath } });
      }
    }

    const klasId = store.state.orders.order.klasId || to.params.klasId || DEFAULT_KLAS_ID;

    const hasValidKlas = () => store.getters["orders/hasValidKlas"];
    if (klasId !== DEFAULT_KLAS_ID && !hasValidKlas()) {
      await store.dispatch("orders/submitKlas", { klasId });
    }

    // check klas
    if (to.meta.requiresValidKlas && !hasValidKlas()) {
      //console.debug("requiresValidKlas", { to });
      return next({ name: "klas" });
    }
    // check orderlines
    if (to.meta.requiresValidOrderlines && !store.getters["orders/hasValidOrderlines"]) {
      //console.debug("requiresValidOrderlines", { to });
      return next({ name: "cataloog", params: { klasId } });
    }
    // check contact
    if (to.meta.requiresValidContact && !store.getters["orders/hasValidContact"]) {
      //console.debug("requiresValidContact", { to });
      return next({ name: "betaalformulier" });
    }
    // check if a valid order is required
    if (to.meta.requiresValidOrder && !store.getters["orders/isValidOrder"]) {
      //console.debug("requiresValidOrder", { to });
      return next({ name: "betaalformulier" });
    }
    // check if any paymentStatus
    if (to.meta.requiresPaymentStatus && !store.getters["orders/hasPaymentStatus"]) {
      //console.debug("requiresPaymentStatus", { to, order: { ...store.state.orders.order } });
      return next({ name: "betaalformulier" });
    }
    // only closed orders
    if (to.meta.requiresClosedOrder && !store.getters["orders/isClosed"]) {
      //console.debug("requiresClosedOrder", { to });
      return next({ name: "cataloog", params: { klasId } });
    }
    // only open orders
    if (to.meta.requiresOpenOrder && store.getters["orders/isClosed"]) {
      //console.debug("requiresOpenOrder", { to });
      return next({ name: "bevestiging" });
    }

    let nextRoute;
    if (to.meta.requiresAppId !== false && !to.query.appId) {
      to.query.appId = store.state.appId;
      nextRoute = { ...to };
    }
    const orderId = store.state.orders.order.id;
    if (orderId && !to.query.orderId) {
      to.query.orderId = orderId;
      nextRoute = { ...to };
    }

    // nextRoude can be undefined
    return next(nextRoute);
  });
};
